<template>
    <GroupReservationHead :reservation="order.reservation" :selectedGroup="order.selectedGroup" :order="order" />
        
    

   

        <fieldset class="mt-8">

            <Summary :order="order" class="lg:hidden" />


            <div v-if="!auto_confirm && !on_trial"
                    class="flex items-start  text-base font-light text-gray-900 mb-4 p-5 bg-gray-100 rounded">

                <svg class="w-6 h-6 text-primary-500 mr-3 flex-shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
                </svg>
                <span v-if="after_payment">
                    Po zaksięgowaniu płatności Twoje zgłoszenie zostanie zweryfikowane i potwierdzone.
                    Po weryfikacji wyślemy na adres e-mail:
                    <b>{{ order.customer.email }}</b> wiadomość z dalszymi instrukcjami.
                </span>
                <span v-else>
                    Twoje zgłoszenie będzie najpierw przez nas weryfikowane. Po weryfikacji wyślemy na adres e-mail:
                    <b>{{ order.customer.email }}</b> wiadomość z dalszymi instrukcjami.
                </span>
            </div>

            

      <div v-if="agreements.length > 0"
                class="flex items-start text-base font-light text-gray-900 rounded">
                <div class="w-full">
                    <div v-for="(agreement, index) in agreements" :key="agreement.id" class="mb-4 last:mb-0">
                        <AgreementBox :agreement="agreement" v-model="acceptedAgreements[index].acceptance"
                            :error="errors[index] || ''" />
                    </div>
                </div>
                </div>


            <fieldset  v-if="has_contract" class="border p-4 mt-8 border-gray-300">
    
                <div v-if="has_contract">
                    <span class="text-base/7 font-semibold text-gray-900 mb-2">Regulamin</span>
                    <div class="mt-2 flex items-start text-base font-light text-gray-900 rounded">
                        <svg class="w-6 h-6 text-primary-500 mr-3 flex-shrink-0 mt-0.5"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12" />
                        </svg>

                 
                        <span class="text-sm">Prosimy o zapoznanie się z regulaminem:
                            
                            
                            <a v-if="pdf_file_contract"
                                :href="pdf_file_contract"
                                target="_blank"
                                class="underline"
                            >
                                Przeczytaj Regulamin zajęć
                            </a>
                            <a v-if="!pdf_file_contract"
                                href="'#'"
                                @click.prevent="showContract()"
                                class="underline"
                            >
                                Przeczytaj Regulamin zajęć
                            </a>.
                            Po zapoznaniu się prosimy o akceptację kliknięciem.</span>

                    </div>
                    <div class="mt-2">
                        <input id="acceptance-agreement" type="checkbox" v-model="contractAccepted"
                            class="h-5 w-5 text-primary-500 focus:ring-primary-500 border-gray-300 rounded mr-3">
                        <label for="acceptance-agreement"
                            class="font-medium hover:underline cursor-pointer text-primary-500">Akceptuję                       regulamin</label>
                    </div>
                </div>
            </fieldset>

            


            <div v-if="auto_confirm || on_trial"
                class="flex items-start bg-gray-100 p-4 mt-8 text-base font-light text-gray-900 rounded">

                <svg class="w-6 h-6 text-primary-500 mr-3 flex-shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                </svg>

                <span>
                    Po złożeniu Zamówienia na adres e-mail <b>{{ order.customer.email }}</b> wyślemy
                    potwierdzenie zapisu na zajęciach, szczegóły dotyczące udziału 
                    <span v-if="on_trial"> w zajęciach próbnych</span> oraz
                    regulamin zajęć.
                </span>

            </div>


            <dl v-if="payment?.account" class="mt-8 space-y-2 text-sm/6 font-semibold text-gray-900">
                <h2>Link do płatności</h2>
                <div class="flex justify-between">
                    <dt class="text-gray-700 font-light">Konto</dt>
                    <dd class="text-gray-900">{{ payment.account }}</dd>
                </div>
            </dl>

        </fieldset>

        <div class="mt-4">
            <label for="remarks" class="block text-sm/6 font-medium text-gray-900">Uwagi do zamówienia</label>
            <textarea id="remarks" v-model="order.remarks" rows="6"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"></textarea>
        </div>



        <div class="my-8">




            <!-- Contract Modal -->
            <div v-if="contract" class="fixed inset-0 z-50 overflow-hidden">
                <!-- Background overlay -->
                <div class="absolute inset-0 bg-black bg-opacity-50" @click="closeContract"></div>

                <!-- Modal content -->
                <div class="relative h-full w-full md:flex md:items-center md:justify-center md:p-4">
                    <!-- Mobile: Fullscreen, Desktop: Centered with max width -->
                    <div
                        class="bg-white h-full w-full md:h-auto md:max-h-[80vh] md:max-w-4xl md:rounded-lg overflow-hidden flex flex-col">
                        <!-- Header -->
                        <div class="flex justify-between items-center p-6 border-b border-gray-200 bg-white">
                            <h3 class="text-xl font-semibold text-gray-900">Umowa i regulamin zajęć</h3>
                            <button type="button" @click="closeContract" class="text-gray-400 hover:text-gray-600 p-2">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>

                        <!-- Content -->
                        <div class="flex-1 overflow-y-auto p-6">
                            <div class="contract text-sm text-gray-700 leading-relaxed" v-html="contract"></div>
                        </div>

                        <!-- Footer with close button -->
                        <div class="p-6 border-t border-gray-200 bg-gray-50">
                            <button type="button" @click="closeContract"
                                class="w-full bg-primary-500 text-white px-4 py-2 rounded-md hover:bg-primary-700 transition-colors">
                                Zamknij
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 
        <p
            class="bg-gray-100 border-l-4 border-primary-500 text-danger-700 p-4 mt-4 text-base font-light text-gray-900">
            Składając zamówienie, zgadzasz się na umowę i warunki uczestnictwa.
        </p>
        -->

   

   
        <NextButton :onNext="handleOrderSubmit" :onPrev="onCancel" :canProceed="canProceed"
            onNextTitle="Kupuję i płacę" />

        
            
 <div v-if="selectedGroup?.noAvailability" class="pt-4 pb-2">
        <PlaceholderContact
            icon='<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-primary-500 mr-3 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" /></svg>'
            title="Lista rezerwowa" subtitle="Niestety, ta grupa zapełniła się dosłownie w tej chwili. Możesz dołączyć do listy rezerwowej, kontaktując się z nami mailowo."
            avatar="/assets/0fa5c838-59f4-4edf-a3f2-b77176fb5eb3.png?width=40&height=40"
            :contactInfo="`<a href='mailto:kontakt.akademiaimprowizacji@gmail.com?subject=Lista rezerwowa: ${selectedGroup?.name}'>kontakt.akademiaimprowizacji@gmail.com</a>`" contactName="Lista rezerwowa" />

    </div>  
    <div v-else class="pt-4 pb-2">
    
        <!-- Ten placeholder moze byc konfigurowalny w settingsach -->
        <PlaceholderContact
            icon='<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-primary-500 mr-3 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" /></svg>'
            title="W przypadku pytań prosimy o kontakt" subtitle=""
            avatar="/assets/0fa5c838-59f4-4edf-a3f2-b77176fb5eb3.png?width=40&height=40"
            contactInfo="<a href='tel:+48781728231'>+48 781 728 231</a>" contactName="Artur Jóskowiak" />
     </div>

  
    <Loading v-if="loading" />
</template>

<script setup>
import Globals from '@shared/model/Globals';
</script>

<script>
import { ref } from 'vue';
import NextButton from './NextButton.vue';
import DocumentIcon from 'vue-material-design-icons/FileDocumentOutline.vue';
import GroupReservationHead from './GroupReservationHead.vue';
import Summary from './Summary.vue';
import Loading from './Loading.vue';
import PlaceholderContact from './PlaceholderContact.vue';
import AgreementBox from './AgreementBox.vue';
export default {
    components: {
        NextButton,
        DocumentIcon,
        GroupReservationHead,
        Summary,
        Loading,
        PlaceholderContact,
        AgreementBox
    },
    props: {
        order: {
            type: Object,
            required: true
        },
        onNext: {
            type: Function,
            required: true
        },
        onCancel: {
            type: Function,
            required: true
        },
        payment: {
            type: Object,
            required: false
        },

    },
    
    
    computed: {
        
        selectedGroup() {
            return this.order.selectedGroup;
        },
  
        auto_confirm() {
            return this.selectedGroup.autoConfirm ;
        },
        after_payment() {
            return this.selectedGroup.paymentRequired ;
        },
        has_contract() {
            return this.selectedGroup.contract !== null && this.selectedGroup.contract !== undefined;
        },
        pdf_file_contract() {
            let pdf = (this.has_contract && !this.selectedGroup.contract.is_pdf_generated)? this.selectedGroup.contract.pdf : null;
            if (!pdf) return null;
            return `/assets/${pdf}.pdf`;
        },
        on_trial() {
            return this.order.onTrial;
        },
 
    },
    methods: {

        handleEligible(val) {
          this.eligible = !!val;
        },

        hasAcceptedAllAgreements() {
            if (this.agreements.length === 0) return true; // No agreements to accept
            return this.acceptedAgreements.every((agreement, index) => {
                if (this.agreements[index].required) {
                    return agreement.acceptance === 'TAK' || agreement.acceptance === true;
                }
                return true; // If not required, always true
            });

        },
        canProceed() {

            if (this.selectedGroup.noAvailability) {
                return false;
            }
            if (this.selectedGroup.hasRequirements) {
                 return !!this.eligible && !!(this.order.getCount && this.order.getCount() > 0);
             }
            

            return (this.contractAccepted || this.has_contract === false) && this.hasAcceptedAllAgreements();
        },
        async handleOrderSubmit() {
            this.loading = true;
            try {
                const ret = await this.order.confirmOrder();
                 
                await new Promise(resolve => setTimeout(resolve, 2000));
                if (ret) {
                    this.onNext();
                } else {
                    alert('Wystąpił błąd podczas składania zamówienia. Proszę spróbować ponownie.');
                }
            } catch (error) {
                console.log(error);
                alert(error.message || 'Wystąpił błąd podczas składania zamówienia. Proszę spróbować ponownie.');
            } finally {
                this.loading = false; // Set loading to false
            }
        },
        async showContract() {
            try {
                
                this.contract = await this.order.genContractContent();
                // Block body scroll
                document.body.style.overflow = 'hidden';
            } catch (error) {
                console.log('Error fetching content:', error);
                alert(error.message || 'Wystąpił błąd podczas pobierania treści umowy.');
            }
        },
        closeContract() {
            this.contract = '';
            // Restore body scroll
            document.body.style.overflow = '';
        }
    },
    data() {
        const agreements = this.order.selectedGroup?.agreements || [];
        return {
            eligible: true,
            loading: false,
            contractAccepted: false,
            contract: '',
            agreements,
            acceptedAgreements: agreements.map(a => ({
                id: a.id,
                title: a.title,
                required: a.required,
                condition: a.condition,
                content: a.content,
                acceptance: '',
                accepted_date: new Date().toISOString()
            })),
            errors: []
        };
    },
    beforeUnmount() {
        // Restore body scroll when component is destroyed
        document.body.style.overflow = '';
    }
}
</script>
